import { render, staticRenderFns } from "./NlpHowItWorks.vue?vue&type=template&id=34f948ac&scoped=true"
import script from "./NlpHowItWorks.vue?vue&type=script&lang=js"
export * from "./NlpHowItWorks.vue?vue&type=script&lang=js"
import style0 from "./NlpHowItWorks.vue?vue&type=style&index=0&id=34f948ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f948ac",
  null
  
)

export default component.exports